import { useState } from 'react';
import styles from './scenario-studio.module.css';

interface JsonEditorProps<T> {
  value: T;
  onChange: (value: T) => void;
  label?: string;
}

export function JsonEditor<T>({ value, onChange, label = 'JSON' }: JsonEditorProps<T>) {
  const [text, setText] = useState(() => JSON.stringify(value, null, 2));
  const [error, setError] = useState<string | null>(null);
  const [open, setOpen] = useState(false);

  const apply = () => {
    try {
      const parsed = JSON.parse(text) as T;
      onChange(parsed);
      setError(null);
      setOpen(false);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'JSON invalide');
    }
  };

  if (!open) {
    return (
      <button type="button" className={styles.btnGhost} onClick={() => { setText(JSON.stringify(value, null, 2)); setOpen(true); }}>
        Éditer {label} (JSON)
      </button>
    );
  }

  return (
    <div className={styles.jsonEditor}>
      <label>{label}</label>
      <textarea
        className={styles.textarea}
        rows={12}
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
      {error && <p className={styles.errorText}>{error}</p>}
      <div className={styles.row}>
        <button type="button" className={styles.btnPrimary} onClick={apply}>Appliquer</button>
        <button type="button" className={styles.btnSecondary} onClick={() => setOpen(false)}>Annuler</button>
      </div>
    </div>
  );
}
